var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page flex-col"
  }, [_c("div", {
    staticClass: "group2 flex-row justify-between"
  }, [_c("div", {
    staticClass: "block2 flex-col",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    staticClass: "imgBack",
    attrs: {
      src: require("../../assets/images/back.png"),
      alt: ""
    },
    on: {
      click: _vm.back
    }
  })]), _c("span", {
    staticClass: "word1"
  }, [_vm._v("New MG EP Plus")])]), _vm._m(0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "box1 flex-col"
  }, [_c("div", {
    staticClass: "block3 flex-col"
  }, [_c("img", {
    staticClass: "pic1",
    attrs: {
      referrerpolicy: "no-referrer",
      src: "https://tpage.soimt.com/APP/SNS/brochre_ep.png"
    }
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };